// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
 *  Owl Carousel - Animate Plugin
 */
 .owl-carousel .animated {
    animation-duration: 1000ms;
    animation-fill-mode: both;
  }
  .owl-carousel .owl-animated-in {
    z-index: 0;
  }
  .owl-carousel .owl-animated-out {
    z-index: 1;
  }
  .owl-carousel .fadeOut {
    animation-name: fadeOut;
  }
  @keyframes fadeOut {
    0% {
      opacity: 1;
    }
  
    100% {
      opacity: 0;
    }
  }
  
  /* 
   * 	Owl Carousel - Auto Height Plugin
   */
  .owl-height {
    transition: height 500ms ease-in-out;
  }
  
  /* 
   *  Core Owl Carousel CSS File
   */
  .owl-carousel {
    display: none;
    width: 100%;
    -webkit-tap-highlight-color: transparent;
    /* position relative and z-index fix webkit rendering fonts issue */
    position: relative;
    z-index: 1;
  }
  .owl-carousel .owl-stage {
    position: relative;
    -ms-touch-action: pan-Y;
  }
  .owl-carousel .owl-stage:after {
    content: ".";
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0;
  }
  .owl-carousel .owl-stage-outer {
    position: relative;
    overflow: hidden;
    /* fix for flashing background */
    -webkit-transform: translate3d(0px, 0px, 0px);
  }
  .owl-carousel .owl-controls .owl-nav .owl-prev,
  .owl-carousel .owl-controls .owl-nav .owl-next,
  .owl-carousel .owl-controls .owl-dot {
    cursor: pointer;
    cursor: hand;
    -webkit-user-select: none;
    user-select: none;
  }
  .owl-carousel.owl-loaded {
    display: block;
  }
  .owl-carousel.owl-loading {
    opacity: 0;
    display: block;
  }
  .owl-carousel.owl-hidden {
    opacity: 0;
  }
  .owl-carousel .owl-refresh .owl-item {
    display: none;
  }
  .owl-carousel .owl-item {
    position: relative;
    min-height: 1px;
    float: left;
    -webkit-backface-visibility: hidden;
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
  }
  .owl-carousel .owl-item img {
    display: block;
    width: none;
    -webkit-transform-style: preserve-3d;
  }
  .owl-carousel.owl-text-select-on .owl-item {
    -webkit-user-select: auto;
    user-select: auto;
  }
  .owl-carousel .owl-grab {
    cursor: move;
    cursor: -o-grab;
    cursor: -ms-grab;
    cursor: grab;
  }
  .owl-carousel.owl-rtl {
    direction: rtl;
  }
  .owl-carousel.owl-rtl .owl-item {
    float: right;
  }
  
  /* No Js */
  .no-js .owl-carousel {
    display: block;
  }
  
  /* 
   * 	Owl Carousel - Lazy Load Plugin
   */
  .owl-carousel .owl-item .owl-lazy {
    opacity: 0;
    transition: opacity 400ms ease;
  }
  .owl-carousel .owl-item img {
    transform-style: preserve-3d;
  }
  
  /* 
   * 	Owl Carousel - Video Plugin
   */
  .owl-carousel .owl-video-wrapper {
    position: relative;
    height: 100%;
    background: #000;
  }
  .owl-carousel .owl-video-play-icon {
    position: absolute;
    height: 80px;
    width: 80px;
    left: 50%;
    top: 50%;
    margin-left: -40px;
    margin-top: -40px;
    /* background: url("owl.video.play.png") no-repeat; */
    cursor: pointer;
    z-index: 1;
    -webkit-backface-visibility: hidden;
    transition: scale 100ms ease;
  }
  .owl-carousel .owl-video-play-icon:hover {
    transition: scale(1.3, 1.3);
  }
  .owl-carousel .owl-video-playing .owl-video-tn,
  .owl-carousel .owl-video-playing .owl-video-play-icon {
    display: none;
  }
  .owl-carousel .owl-video-tn {
    opacity: 0;
    height: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    transition: opacity 400ms ease;
  }
  .owl-carousel .owl-video-frame {
    position: relative;
    z-index: 1;
  }
  
  .owl-theme .owl-controls {
        display:block;
  }
  .owl-theme .owl-controls .owl-nav [class*="owl-"] {
    position: relative;
    cursor: pointer;
    display: inline-block;
    color: #898f9f;
    margin: 0px 10px;
    transition: all 500ms ease;
  }
  .owl-theme .owl-controls .owl-nav [class*="owl-"] span:before{
    margin: 0px;
    font-size: 25px;
  }
  .owl-theme .owl-controls .owl-nav [class*="owl-"]:hover{
    color: #f2be00;
  }
  .owl-theme .owl-controls .owl-nav .disabled {
    cursor: default;
    opacity: 0.5;
  }
  .owl-theme .owl-dots .owl-dot {
      display: inline-block;
  }
  .owl-theme .owl-dots .owl-dot span {
    background: #222;
    display: block;
    margin: 0px 5px 0px 5px;
    transition: opacity 200ms ease 0s;
     height: 15px;
  }
  .owl-theme .owl-dots .owl-dot.active span {
    background: none repeat scroll 0 0 #cda274;
  }`, "",{"version":3,"sources":["webpack://./src/CustomCSS/css/owl.css"],"names":[],"mappings":"AAAA;;EAEE;CACD;IAEG,0BAA0B;IAE1B,yBAAyB;EAC3B;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IAEE,uBAAuB;EACzB;EAWA;IACE;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;EACF;;EAEA;;IAEE;EACF;IAKE,oCAAoC;EACtC;;EAEA;;IAEE;EACF;IACE,aAAa;IACb,WAAW;IACX,wCAAwC;IACxC,mEAAmE;IACnE,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,6CAA6C;EAC/C;EACA;;;IAGE,eAAe;IACf,YAAY;IACZ,yBAAyB;IAIzB,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,UAAU;IACV,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,mCAAmC;IACnC,wCAAwC;IACxC,2BAA2B;IAC3B,yBAAyB;IAGzB,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,WAAW;IACX,oCAAoC;EACtC;EACA;IACE,yBAAyB;IAGzB,iBAAiB;EACnB;EACA;IACE,YAAY;IAEZ,eAAe;IACf,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;;EAEA,UAAU;EACV;IACE,cAAc;EAChB;;EAEA;;IAEE;EACF;IACE,UAAU;IAKV,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;;EAEA;;IAEE;EACF;IACE,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;IACjB,qDAAqD;IACrD,eAAe;IACf,UAAU;IACV,mCAAmC;IAKnC,4BAA4B;EAC9B;EACA;IAKE,2BAA2B;EAC7B;EACA;;IAEE,aAAa;EACf;EACA;IACE,UAAU;IACV,YAAY;IACZ,kCAAkC;IAClC,4BAA4B;IAI5B,wBAAwB;IAKxB,8BAA8B;EAChC;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;;EAEA;QACM,aAAa;EACnB;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,0BAA0B;EAC5B;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;MACI,qBAAqB;EACzB;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,iCAAiC;KAChC,YAAY;EACf;EACA;IACE,0CAA0C;EAC5C","sourcesContent":["/* \n *  Owl Carousel - Animate Plugin\n */\n .owl-carousel .animated {\n    -webkit-animation-duration: 1000ms;\n    animation-duration: 1000ms;\n    -webkit-animation-fill-mode: both;\n    animation-fill-mode: both;\n  }\n  .owl-carousel .owl-animated-in {\n    z-index: 0;\n  }\n  .owl-carousel .owl-animated-out {\n    z-index: 1;\n  }\n  .owl-carousel .fadeOut {\n    -webkit-animation-name: fadeOut;\n    animation-name: fadeOut;\n  }\n  \n  @-webkit-keyframes fadeOut {\n    0% {\n      opacity: 1;\n    }\n  \n    100% {\n      opacity: 0;\n    }\n  }\n  @keyframes fadeOut {\n    0% {\n      opacity: 1;\n    }\n  \n    100% {\n      opacity: 0;\n    }\n  }\n  \n  /* \n   * \tOwl Carousel - Auto Height Plugin\n   */\n  .owl-height {\n    -webkit-transition: height 500ms ease-in-out;\n    -moz-transition: height 500ms ease-in-out;\n    -ms-transition: height 500ms ease-in-out;\n    -o-transition: height 500ms ease-in-out;\n    transition: height 500ms ease-in-out;\n  }\n  \n  /* \n   *  Core Owl Carousel CSS File\n   */\n  .owl-carousel {\n    display: none;\n    width: 100%;\n    -webkit-tap-highlight-color: transparent;\n    /* position relative and z-index fix webkit rendering fonts issue */\n    position: relative;\n    z-index: 1;\n  }\n  .owl-carousel .owl-stage {\n    position: relative;\n    -ms-touch-action: pan-Y;\n  }\n  .owl-carousel .owl-stage:after {\n    content: \".\";\n    display: block;\n    clear: both;\n    visibility: hidden;\n    line-height: 0;\n    height: 0;\n  }\n  .owl-carousel .owl-stage-outer {\n    position: relative;\n    overflow: hidden;\n    /* fix for flashing background */\n    -webkit-transform: translate3d(0px, 0px, 0px);\n  }\n  .owl-carousel .owl-controls .owl-nav .owl-prev,\n  .owl-carousel .owl-controls .owl-nav .owl-next,\n  .owl-carousel .owl-controls .owl-dot {\n    cursor: pointer;\n    cursor: hand;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n  }\n  .owl-carousel.owl-loaded {\n    display: block;\n  }\n  .owl-carousel.owl-loading {\n    opacity: 0;\n    display: block;\n  }\n  .owl-carousel.owl-hidden {\n    opacity: 0;\n  }\n  .owl-carousel .owl-refresh .owl-item {\n    display: none;\n  }\n  .owl-carousel .owl-item {\n    position: relative;\n    min-height: 1px;\n    float: left;\n    -webkit-backface-visibility: hidden;\n    -webkit-tap-highlight-color: transparent;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n  }\n  .owl-carousel .owl-item img {\n    display: block;\n    width: none;\n    -webkit-transform-style: preserve-3d;\n  }\n  .owl-carousel.owl-text-select-on .owl-item {\n    -webkit-user-select: auto;\n    -moz-user-select: auto;\n    -ms-user-select: auto;\n    user-select: auto;\n  }\n  .owl-carousel .owl-grab {\n    cursor: move;\n    cursor: -webkit-grab;\n    cursor: -o-grab;\n    cursor: -ms-grab;\n    cursor: grab;\n  }\n  .owl-carousel.owl-rtl {\n    direction: rtl;\n  }\n  .owl-carousel.owl-rtl .owl-item {\n    float: right;\n  }\n  \n  /* No Js */\n  .no-js .owl-carousel {\n    display: block;\n  }\n  \n  /* \n   * \tOwl Carousel - Lazy Load Plugin\n   */\n  .owl-carousel .owl-item .owl-lazy {\n    opacity: 0;\n    -webkit-transition: opacity 400ms ease;\n    -moz-transition: opacity 400ms ease;\n    -ms-transition: opacity 400ms ease;\n    -o-transition: opacity 400ms ease;\n    transition: opacity 400ms ease;\n  }\n  .owl-carousel .owl-item img {\n    transform-style: preserve-3d;\n  }\n  \n  /* \n   * \tOwl Carousel - Video Plugin\n   */\n  .owl-carousel .owl-video-wrapper {\n    position: relative;\n    height: 100%;\n    background: #000;\n  }\n  .owl-carousel .owl-video-play-icon {\n    position: absolute;\n    height: 80px;\n    width: 80px;\n    left: 50%;\n    top: 50%;\n    margin-left: -40px;\n    margin-top: -40px;\n    /* background: url(\"owl.video.play.png\") no-repeat; */\n    cursor: pointer;\n    z-index: 1;\n    -webkit-backface-visibility: hidden;\n    -webkit-transition: scale 100ms ease;\n    -moz-transition: scale 100ms ease;\n    -ms-transition: scale 100ms ease;\n    -o-transition: scale 100ms ease;\n    transition: scale 100ms ease;\n  }\n  .owl-carousel .owl-video-play-icon:hover {\n    -webkit-transition: scale(1.3, 1.3);\n    -moz-transition: scale(1.3, 1.3);\n    -ms-transition: scale(1.3, 1.3);\n    -o-transition: scale(1.3, 1.3);\n    transition: scale(1.3, 1.3);\n  }\n  .owl-carousel .owl-video-playing .owl-video-tn,\n  .owl-carousel .owl-video-playing .owl-video-play-icon {\n    display: none;\n  }\n  .owl-carousel .owl-video-tn {\n    opacity: 0;\n    height: 100%;\n    background-position: center center;\n    background-repeat: no-repeat;\n    -webkit-background-size: contain;\n    -moz-background-size: contain;\n    -o-background-size: contain;\n    background-size: contain;\n    -webkit-transition: opacity 400ms ease;\n    -moz-transition: opacity 400ms ease;\n    -ms-transition: opacity 400ms ease;\n    -o-transition: opacity 400ms ease;\n    transition: opacity 400ms ease;\n  }\n  .owl-carousel .owl-video-frame {\n    position: relative;\n    z-index: 1;\n  }\n  \n  .owl-theme .owl-controls {\n        display:block;\n  }\n  .owl-theme .owl-controls .owl-nav [class*=\"owl-\"] {\n    position: relative;\n    cursor: pointer;\n    display: inline-block;\n    color: #898f9f;\n    margin: 0px 10px;\n    transition: all 500ms ease;\n  }\n  .owl-theme .owl-controls .owl-nav [class*=\"owl-\"] span:before{\n    margin: 0px;\n    font-size: 25px;\n  }\n  .owl-theme .owl-controls .owl-nav [class*=\"owl-\"]:hover{\n    color: #f2be00;\n  }\n  .owl-theme .owl-controls .owl-nav .disabled {\n    cursor: default;\n    opacity: 0.5;\n  }\n  .owl-theme .owl-dots .owl-dot {\n      display: inline-block;\n  }\n  .owl-theme .owl-dots .owl-dot span {\n    background: #222;\n    display: block;\n    margin: 0px 5px 0px 5px;\n    transition: opacity 200ms ease 0s;\n     height: 15px;\n  }\n  .owl-theme .owl-dots .owl-dot.active span {\n    background: none repeat scroll 0 0 #cda274;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
